import styles from "./styles.module.scss";

type CardTitleProps = {
  title: string;
  width?: number;
  style?: React.CSSProperties;
  paddingLeft?: number;
  titleStyles?: React.CSSProperties;
};
const CardTitle: React.FC<CardTitleProps> = (props) => {
  const style = props.width
    ? {
        width: props.width,
        overflow: "hidden",
        ...(props.style || {}),
      }
    : {};

  const titleStyles = props.titleStyles || {};
  return (
    <div className={styles.maxWidth} style={style}>
      <div className={styles.cardTitle} style={titleStyles}>
        {props.title}
      </div>
    </div>
  );
};

export default CardTitle;
